import ko from 'knockout';
import { defineComponent } from '@/gr/common/knockout/defineComponent';
import { CompositeDisposable } from '@/gr/common/disposable';
import { InputDataDefinitionChooserState } from '@/apps/timeSeriesViewer';
import '@/gr/common/knockout/bindings/fastForEach';

export class Component {
  private _disposable = new CompositeDisposable();

  readonly searchQuery;
  readonly hasSearched = ko.pureComputed(() => this.searchQuery().length > 0);
  isFocused = ko.observable(true);
  triggerImmediateSearch;

  constructor(private _args: Args) {
    this.searchQuery = this._args.search;
    this.triggerImmediateSearch = this._args.triggerImmediateSearch;
  }

  dispose(): void {
    this._disposable.dispose();
  }

  onKeyPress(vm: this, event: KeyboardEvent): boolean {
    if (event.keyCode === 13 /* enter */) {
      this._args.triggerImmediateSearch();
    }
    return true; /* allow default event action */
  }

  clearSearch(): void {
    this.searchQuery('');
    this._args.triggerImmediateSearch();
  }
}

export class Args {
  constructor(
    public search: KnockoutObservable<string>,
    public triggerImmediateSearch: () => void
  ) {}
}

export class ArgsFactory {
  create(state: InputDataDefinitionChooserState, triggerImmediateSearch: () => void): Args {
    return new Args(state.search, triggerImmediateSearch);
  }
}

import html from './searchBoxComponent.html';
defineComponent(() => Component, 'searchBox', html);
require('./searchBoxComponent.less');
